export const NAV_SET_MAIN_VIEW = 'NAV_SET_MAIN_VIEW';
export const NAV_SET_SUB_VIEW = 'NAV_SET_SUB_VIEW';
export const NAV_SET_IS_AUTH = 'NAV_SET_IS_AUTH';
